<div class="col-12 col-md-4 p-2" *ngIf="showReportName">
  <h4 class="mt-3 mb-3 font-weight-bold">{{ tableName }}</h4>
</div>
<div class="bg-white rounded row mx-0 shadow-sm">
  <div class="col-12 table-header my-2">
    <div class="table-right-control" #configureTable>
      <div *ngIf="showTopBar" class="row mx-0 justify-content-end">
        <div class="col-auto px-0">
          <mat-selection-list
            [(ngModel)]="selectedColumns"
            (selectionChange)="onSelectColumn($event)"
            class="mat-elevation-z3 list-config bg-white"
            [style.display]="configVisible ? 'initial' : 'none'"
          >
            <mat-list-option
              *ngFor="let columnName of defaultColumns"
              [value]="columnName"
            >
              {{ columnsDisplayNames[columnName] || columnName | titlecase }}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="col-auto px-0 row mx-0 justify-content-end">
          <div class="col-auto w-sm-100 px-0">
            <div class="input-group mx-auto mt-2">
              <input
                class="form-control"
                type="text"
                placeholder="{{ 'Sellers.Products.Search' | translate }}"
                [(ngModel)]="searchKey"
                (keydown.enter)="onSearch()"
              />
              <span class="input-group-text clear-btn" *ngIf="searchKey" (click)="clearSearchF()">
                <i class="fa fa-times"></i>
              </span>
              <button class="btn btn-primary" (click)="onSearch()">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <div class="col-auto px-0">
            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.ConfigureTable' | translate }}"
              (click)="
                configVisible
                  ? (configVisible = false && configClosed())
                  : (configVisible = true)
              "
              class="table-right-control-btn"
            >
              <i class="fa fa-columns"></i>
            </button>

            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.Print' | translate }}"
              class="table-right-control-btn"
              (click)="print()"
            >
              <i class="fa fa-print"></i>
            </button>
            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.ExportPDF' | translate }}"
              (click)="exportAs('pdf')"
              class="table-right-control-btn"
            >
              <i class="fa fa-file-pdf"></i>
            </button>
            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.ExportExcel' | translate }}"
              (click)="exportAs('xlsx')"
              class="table-right-control-btn"
            >
              <i class="fa fa-file-excel"></i>
            </button>
            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.ExportCSV' | translate }}"
              (click)="exportAs('csv')"
              class="table-right-control-btn"
            >
              <i class="fa fa-file-csv"></i>
            </button>
            <button
              mat-flat-button
              type="button"
              matTooltip="{{ 'Sellers.Products.CopiedToClipboard' | translate }}"
              (click)="copyToClipBoard()"
              class="table-right-control-btn"
            >
              <i class="fa fa-clone"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0 justify-content-end mb-3" *ngIf="hasActiveSelection">
      <div class="col-auto px-1" *ngFor="let action of selectionActions">
        <div *ngIf="determineCondition(action)">
          <div *ngIf="action.actionType == 'Button'">
            <button
              class="btn btn-sm {{ action.actionClass }}"
              (click)="selectionActionClickF(action.actionValue)"
            >
              {{ action.actionName }}
            </button>
          </div>
          <div *ngIf="action.actionType == 'Disabled Button'">
            <button
              class="btn btn-sm {{ action.actionClass }}"
              (click)="selectionActionClickF(action.actionValue)"
              disabled
            >
              {{ action.actionName }} : {{ selection.selected.length }}
            </button>
          </div>
          <div *ngIf="action.actionType == 'icon'">
            <button
              class="btn btn-sm btn-primary"
              matTooltip="{{ action.actionName }}"
              (click)="selectionActionClickF(action.actionValue)"
            >
              <i class="fa {{ action.iconClass }}"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="table-responsive bg-white shadow rounded"
      style="overflow-x: auto"
    >
      <!-- Loader -->
      <div id="loader" *ngIf="tableLoading">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
      <div id="{{ tableName ? tableName + '_report' : '_report' }}">
      <table
        #reportTable
        mat-table
        [dataSource]="data"
        *ngIf="data?.length"
        (matSortChange)="sortData($event)"
        style="width: max-content !important"
        matSort
      >
        <ng-container *ngIf="hasCheckboxes">
          <ng-container matColumnDef="select">
            <th class="select-cell" mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td class="select-cell" mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [disabled]="!isRowSelectable(row)"
                [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
        </ng-container>

        <ng-container
          *ngFor="let columnName of defaultColumns; let indexColumn = index"
        >
          <ng-container matColumnDef="{{ columnName }}">
            {{ columnName | titlecase | translate }}
            <th
              mat-header-cell
              class="text-center px-3"
              *matHeaderCellDef
              mat-sort-header
            >
              {{ columnsDisplayNames[columnName] || columnName | titlecase | translate}}
            </th>
            <td
              mat-cell
              *matCellDef="let element; let indexRow = index"
              class="text-center px-2"
              [class.loader]="tableLoading"
            >
              <a
                *ngIf="isValidUrl(element)"
                class="text-primary"
                href="{{ element[columnName] }}"
                target="_blank"
                >{{ element[columnName] | translate}}</a
              >
              <a
                *ngIf="
                  LinkingCoulmns && LinkingCoulmns[columnName] && !isClickable
                "
                class="text-primary"
                href="{{
                  LinkingCoulmns[columnName].base +
                    element[LinkingCoulmns[columnName].varName]
                }}"
                target="_blank"
                >{{ element[columnName] }}</a
              >
              <a
                *ngIf="
                  LinkingCoulmns && LinkingCoulmns[columnName] && isClickable
                "
                class="text-primary"
                href="{{ element[columnName] }}"
                target="_blank"
                >{{ element[columnName] }}</a
              >
              <span
                *ngIf="columnTypes && columnTypes[columnName] === 'boolean'"
              >
                <span title="Verified" *ngIf="element[columnName]"
                  >&#10004;</span
                >
                <span title="Un-verified" *ngIf="!element[columnName]"
                  >&#10008;</span
                >
              </span>
              <span
                *ngIf="
                  columnTypes && columnTypes[columnName] === 'businessType'
                "
              >
                <span title="Verified" *ngIf="element[columnName] === 'Company'"
                  >&#10004;</span
                >
                <span
                  title="Un-verified"
                  *ngIf="element[columnName] === 'Individual'"
                  >&#10008;</span
                >
                <span title="Un-verified" *ngIf="element[columnName] === 'Junk'"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></span>
              </span>
              <span
                [ngClass]="{
                  clickable: isClickable && columnNameToClick == columnName
                }"
                *ngIf="
                  !isValidUrl(element) &&
                  (!LinkingCoulmns ||
                    (LinkingCoulmns && !LinkingCoulmns[columnName])) &&
                  !(
                    (columnTypes && columnTypes[columnName] === 'boolean') ||
                    (columnTypes &&
                      columnTypes[columnName] === 'businessType') ||
                    (columnTypes && columnTypes[columnName] === 'html')
                  )
                "
                (click)="
                  columnNameToClick && columnNameToClick == columnName
                    ? columnClicked(element[columnName])
                    : ''
                "
              >
                {{ element[columnName] || ""  |translate}}
              </span>
              <span
                *ngIf="
                  hasCancelRequest && indexColumn == defaultColumns.length - 1
                "
                [ngClass]="{
                  'disabled-btn-container':
                    data[indexRow]['isEnabled'] == 'Enabled' ||
                    data[indexRow]['status'] == 'paid' ||
                    data[indexRow]['status'] == 'cancelled'
                }"
              >
                <button
                  [disabled]="
                    data[indexRow]['isEnabled'] == 'Enabled' ||
                    data[indexRow]['status'] == 'paid' ||
                    data[indexRow]['status'] == 'cancelled'
                  "
                  type="button"
                  (click)="cancelRequestToParent(indexRow)"
                  class="btn btn-danger btn-sm"
                >
                  cancel
                </button>
              </span>
            </td>
            <ng-container *ngIf="total">
              <td mat-footer-cell *matFooterCellDef class="total-bold">
                {{ getFooterValue(columnName) }}
              </td>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="hasRowActions">
          <ng-container matColumnDef="actions">
            <th mat-header-cell class="text-center px-3" *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let element; let indexOfelement = index"
              class="text-center px-3"
              [class.loader]="tableLoading"
            >
              <ng-container *ngFor="let action of rowActions">
                <ng-container *ngIf="action.actionType == 'Button'">
                  <button
                    class="btn bg-primary btn-sm {{ action.actionClass }}"
                    (click)="
                      rowActionClickF(
                        rowActionKeyName ? element[rowActionKeyName] : element,
                        action.actionName
                      )
                    "
                  >
                    {{ action.actionName }}
                  </button>
                </ng-container>
                <ng-container *ngIf="action.actionType == 'icon'">
                  <button
                    [disabled]="isRowActionDisabled(indexOfelement, action)"
                    class="btn btn-sm {{ action.actionClass }}"
                    matTooltip="{{ action.actionName }}"
                    (click)="
                      rowActionClickF(
                        rowActionKeyName ? element[rowActionKeyName] : element,
                        action.actionName
                      )
                    "
                  >
                    <i class="fa {{ action.iconClass }}"></i>
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>

        <ng-container matColumnDef="expandedDetail"> data test </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          matRipple
          class="element-row"
          [class.expanded]="expandedElement == row"
          (click)="expandedElement = row; rowClick()"
        ></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: ['expandedDetail'];
            when: isExpansionDetailRow
          "
          [@detailExpand]="
            row.element == expandedElement ? 'expanded' : 'collapsed'
          "
          style="overflow: hidden"
        ></tr>
        <ng-container *ngIf="total">
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </ng-container>
      </table>
    </div>
    </div>
  </div>

  <div
    class="col-12 border-top border-bottom text-center py-4"
    *ngIf="!data.length"
  >
    <h5 class="text-primary">{{ "Sellers.Products.NoData" | translate }}</h5>
  </div>

  <div>
    <mat-paginator
      [length]="rowsLength"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 15, 20, rowsLength]"
      (page)="paginate($event)"
    >
    </mat-paginator>
  </div>
</div>
